import { FC } from 'react';

import { PlayFilledSize16 } from '@hh.ru/magritte-ui/icon';
import { Link } from '@hh.ru/redux-spa-middleware';

import BlokoLink from 'bloko/blocks/link';

import useTrls from 'hooks/translation/useTrls';

import PreviewTip from 'components/Banner/Preview/PreviewTip';

import { useSelector } from 'store/utils';

import styles from 'components/Banner/Preview/BannerPreviewImage/BannerPreviewImage.module.less';

interface BannerPreviewImageProps {
    bannerAction: string;
    imageUrl: string;
    isCampaignArchived: boolean;
    isReadOnlyAccount: boolean;
    hasVideo: boolean;
    isInformationCampaign: boolean;
}

const tipTrl = 'dashboard.CampaignList.Banner.Preview.tip.noEdit';

const BannerPreviewImage: FC<BannerPreviewImageProps> = ({
    bannerAction,
    imageUrl,
    isCampaignArchived,
    isReadOnlyAccount,
    hasVideo,
    isInformationCampaign,
}) => {
    const webdavPublicUrl = useSelector((state) => state.clickme.webdavPublicUrl);
    const imgNode = (
        <div className={styles.bannerPreviewImageContainer}>
            <img className={styles.bannerPreviewImage} src={`${webdavPublicUrl}/${imageUrl}`} />
            {hasVideo && (
                <div className={styles.bannerPreviewImageVideo}>
                    <PlayFilledSize16 initialColor="contrast" />
                </div>
            )}
        </div>
    );

    const trl = useTrls();

    if (isReadOnlyAccount) {
        return imgNode;
    }
    if (!isCampaignArchived) {
        return isInformationCampaign ? (
            <BlokoLink Element={Link} to={bannerAction}>
                {imgNode}
            </BlokoLink>
        ) : (
            <PreviewTip tipText={trl(tipTrl)}>{imgNode}</PreviewTip>
        );
    }
    return imgNode;
};

export default BannerPreviewImage;
